<template>
    <div class="sidebar" style="background: #e8e9fe">
        <!-- Logo区域 -->
        <div class="logo-section">
            <div class="logo">
                <div class="logo-icon">
                    <img src="@/assets/dake_heng.png" width="140" />
                </div>
<!--                <div class="logo-text">-->
<!--                    <div class="brand-name">大可AI</div>-->
<!--                    <div class="brand-subtitle">新媒体营销智能平台</div>-->
<!--                </div>-->
            </div>
        </div>

        <!-- 导航菜单：只显示一级菜单 -->
        <el-menu
            style="background: #e8e9fe"
            :default-active="$route.name"
            class="sidebar-menu"
            @select="handleMenuSelect"
            unique-opened
        >
            <el-menu-item
                v-for="item in menuItems"
                :key="item.name"
                :index="item.name"
            >
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
            </el-menu-item>
        </el-menu>

        <!-- 底部设置 -->
        <div class="sidebar-footer">
            <el-menu class="footer-menu">
                <!-- 可选的底部菜单 -->
            </el-menu>
        </div>
    </div>
</template>

<script>
import { getShopByUserId } from '@/api/login'

export default {
    name: 'Sidebar',
    data() {
        return {
            shop: {},
            userId: null,
            menuItems: [
                { name: 'IndustryKnowledge', title: '行业知识', icon: 'el-icon-reading' },
                { name: 'Dashboard', title: '仪表盘', icon: 'el-icon-s-dashboard' },
                { name: 'NoteModule', title: '内容创作', icon: 'el-icon-s-cooperation', children: [
                        { name: 'NoteTextManage', title: '图文笔记创作', icon: 'el-icon-tickets',disabled: false },
                        { name: 'NoteVideoManage', title: '短视频一键转笔记', icon: 'el-icon-video-camera',disabled: false },
                        { name: 'FireCopyManage', title: '爆文结构复用', icon: 'el-icon-video-camera', disabled: false },
                        { name: 'ShortVideoManage', title: '短视频笔记创作', icon: 'el-icon-video-camera' ,disabled: false},
                        { name: 'NoteLiveManage', title: '笔记直播创作', icon: 'el-icon-video-camera',disabled: true },
                        // { name: 'TestManage', title: '测评管理', icon: 'el-icon-video-camera',disabled: true },
                    ]},
                { name: 'NoteManage', title: '笔记管理', icon: 'el-icon-document' },
                { name: 'ProductManage', title: '商品管理', icon: 'el-icon-edit-outline' },
                { name: 'OrderManage', title: '账单管理', icon: 'el-icon-s-order' }
            ]
        }
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('user_info'))
        this.userId = this.userInfo.id
        this.getsShopByUserId()
      var item = localStorage.getItem("user_info");
      if (item) {
        this.userInfo = JSON.parse(item);
        if (this.userInfo.id===1){
          this.menuItems= [
            { name: 'IndustryKnowledge', title: '行业知识', icon: 'el-icon-reading' },
            { name: 'Dashboard', title: '仪表盘', icon: 'el-icon-odometer' },
            { name: 'NoteModule', title: '内容创作', icon: 'el-icon-s-cooperation', children: [
                { name: 'NoteTextManage', title: '图文笔记创作', icon: 'el-icon-tickets',disabled: false },
                { name: 'NoteVideoManage', title: '短视频一键转笔记', icon: 'el-icon-video-camera',disabled: false },
                { name: 'FireCopyManage', title: '爆文结构复用', icon: 'el-icon-video-camera', disabled: false },
                { name: 'ShortVideoManage', title: '短视频笔记创作', icon: 'el-icon-video-camera' ,disabled: false},
                { name: 'NoteLiveManage', title: '笔记直播创作', icon: 'el-icon-video-camera',disabled: true },
                // { name: 'TestManage', title: '测评管理', icon: 'el-icon-video-camera',disabled: true },
              ]},
            { name: 'NoteManage', title: '笔记管理', icon: 'el-icon-document' },
            { name: 'TaskManage', title: '任务管理', icon: 'el-icon-document' },
            { name: 'ProductManage', title: '商品管理', icon: 'el-icon-edit-outline' },
            { name: 'OrderManage', title: '账单管理', icon: 'el-icon-s-order' }
          ]
        }
      }
    },
    methods: {
        getsShopByUserId() {
            getShopByUserId(this.userId).then(res => {
                this.shop = res.data
            })
        },
        handleMenuSelect(routeName) {
            if (this.$route.name !== routeName) {
                this.$emit('menu-change', routeName)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.sidebar {
    height: 90vh;
    display: flex;
    flex-direction: column;
    background: white;
}

.el-menu {
    background: #e8e9fe;
}

.logo-section {
    padding: $spacing-lg;
    border-bottom: 1px solid $border-color;

    .logo {
        display: flex;
        align-items: center;

        .logo-icon {
            margin-right: 12px;
        }

        .brand-name {
            font-size: $font-size-xl;
            font-weight: 600;
        }

        .brand-subtitle {
            font-size: 8px;
            color: $text-secondary;
            margin-top: 2px;
        }
    }
}

.sidebar-menu {
    flex: 1;
    border: none;

    .el-menu-item {
        height: 48px;
        line-height: 48px;
    }
}
</style>
